import script from "./AssinarContrato.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssinarContrato.vue?vue&type=script&lang=ts&setup=true"

import "./AssinarContrato.vue?vue&type=style&index=0&id=7d91bd77&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d91bd77"]])

export default __exports__